<template>
    <div width="100%">
    <div :class="this.css_class+' img-wrapper'">
        <template v-if="this.is_url==false">
            <img  :class="this.css_class+' figure'" :src="require('@/assets/'+this.src)" :style="'max-height:'+this.imgHeight+'; max-width:'+this.imgWidth+';'+this.background_color_css" >
        </template>
        <template v-if="this.is_url">
            <img :class="this.css_class+' figure'" :src="this.src" :style="'max-height:'+this.imgHeight+'; max-width:'+this.imgWidth+';'+this.background_color_css">
        </template>
        <div :class="this.css_class+' caption'">
            <div style="text-align:left" ref="caption">
                <slot></slot>
            </div>
        </div>
    </div>
    </div>
</template>

<script>
export default {
    name:"CaptionImage",
    props:{
        src:{
           default: "logo.png",
           type: String
       },imgWidth:{
           default: "100%",
           type: String
       },imgHeight:{
           default: "100%",
           type: String
       }, wrapRight:{
           default: true,
           type: Boolean
       }, setWhiteBackground:{
           default: false,
           type: Boolean
       }
    },
    data:function() {
            return{is_url:false,
            css_class:"",
            background_color_css:"background-color:none"}        
        },
    methods:{
        onWindowResize:function() {
            //Set correct css for caption setting
            if(this.wrapRight){
                this.css_class = "single_row_wrapper";
            }else{
                this.css_class = "two_row_wrapper";
            }
            //Set two row wrapper if on mobile or no caption set
            if(window.innerWidth < 600 || this.$refs.caption.innerText==""){
                this.css_class = "two_row_wrapper";
            }
        }
    },
    mounted:function() {
        // Check if img require fetchinf from url
        if(this.src.length >= 4){
            if(this.src.substring(0, 4)=='http'){
                this.is_url=true;        
            }
        }
        //set white background
        if(this.setWhiteBackground){
            this.background_color_css = "background-color:#F0F0F0"
        }
        this.onWindowResize()
    },
    created() {
        window.addEventListener("resize", this.onWindowResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onWindowResize);
    }
    
}
</script>

<style scoped>
    .img-wrapper{
        font-weight:lighter;
        padding:1rem;
        display: grid;
        overflow:break-word;
        justify-content: center;
        margin:auto;
        grid-gap: 1rem;
    }

    .single_row_wrapper{
        grid-template-columns: auto 30%;
    }

    /*Always wrap caption on mobile */
    @media screen and (max-width: 600px) {
        .single_row_wrapper {
            grid-template-columns: auto;
        }
    }

    
    .two_row_wrapper{
        grid-template-columns: auto;
    }
    .caption{
        color: #89ACD7;
        font-size: 0.9rem;
    }
    .single_row_wrapper.caption{
        text-align: left;
    }
    .two_row_wrapper.caption{
        text-align:center;
    }

    .figure{
        object-fit: cover;
        width: auto;
        height: auto;
        border-radius: .25rem;
    }
    .two_row_wrapper.figure{
        margin: auto;
    }

</style>